import { compact, isEmpty, sortBy } from 'lodash';

export function fullname(usuario, format) {
  // Si no pasan el formato por defecto es true
  if (format !== false) {
    return `${compact([usuario.apellido1, usuario.apellido2]).join(' ')}, ${usuario.nombre}`;
  }

  return compact([usuario.nombre, usuario.apellido1, usuario.apellido2]).join(' ');
}

export function iniciales(usuario) {
  return fullname(usuario).split(/\s+/).map((parte) => (
    (parte[0] || '').toUpperCase()
  )).join('.');
}

export function ordenar(usuarios, format) {
  const collator = new Intl.Collator({ caseFirst: false });
  return usuarios.sort((a, b) => (
    collator.compare(fullname(a, format), fullname(b, format))
  ));
}

export function iconos(usuario) {
  const iconos = [];

  if (!isEmpty(usuario.caracteristicas)) {
    if (usuario.caracteristicas.alumno) {
      iconos.push({
        clases: 'fa fa-user text-alumno',
        i18n: 'Alumno',
      });
    }
    if (usuario.caracteristicas.profesor) {
      iconos.push({
        clases: 'fa fa-user-graduate text-profesor',
        i18n: 'Profesor',
      });
    }
    if (usuario.caracteristicas.padre) {
      iconos.push({
        clases: 'fa fa-user-tie text-padre',
        i18n: 'Padre',
      });
    }
  }

  // Si no tiene nada, ponemos uno genérico
  if (isEmpty(iconos)) {
    iconos.push({
      clases: 'fa fa-user fa-blank',
      i18n: 'Usuario',
    });
  }

  // Tal como los procesamos, el primer icono es el principal
  iconos[0].principal = true;

  return iconos;
}